import { cloneJson, parseJson } from '../../../utils/safeJson'
import { getCurrentOrganizationId } from '../../../state/organizationContextOptions'

const DEFAULT_TEXT_COLOR = '#314C61'
const DEFAULT_BACKGROUND_COLOR = '#ffffff'
const DEFAULT_ICON = { name: 'mdi mdi-alert-outline', color: '#989898' }

export function createInitAlarmPanel(orgId = getCurrentOrganizationId()) {
  return {
    name: null,
    description: null,
    orgId,
    rows: [],
  }
}

export function createSelectedAlarmPanel() {
  return {
    id: null,
    name: null,
    description: null,
    orgName: null,
    rows: [],
  }
}

export function createEmptyPanelButton() {
  return {
    bgColor: DEFAULT_BACKGROUND_COLOR,
    textColor: DEFAULT_TEXT_COLOR,
    icon: { ...DEFAULT_ICON },
  }
}

export function createNewAlarmPanelDraft(orgId = getCurrentOrganizationId()) {
  return {
    actionButton: { bottom: true, reset: '', trigger: '', unlock: '' },
    allowedUsers: [],
    backGroundColor: '',
    description: '',
    id: null,
    fontSize: 10,
    name: '',
    orgId,
    pdfFile: { file: '', title: '' },
    returnButton: true,
    rows: [{
      buttons: [{
        'custom-name': '',
        alarmName: '',
        alarmid: '',
        bgColor: '',
        existable: true,
        id: '',
        textColor: '',
      }],
      text: '',
    }],
    separator: true,
  }
}

export function parsePanelIcon(icon) {
  const parsedIcon = parseJson(icon, icon)

  return parsedIcon && typeof parsedIcon === 'object' ? parsedIcon : { ...DEFAULT_ICON }
}

export function normalizeAlarmPointDto(alarmPoint, options = {}) {
  const normalizedAlarmPoint = alarmPoint && typeof alarmPoint === 'object' ? { ...alarmPoint } : {}

  if (options.stringifyId && normalizedAlarmPoint.id !== null) {
    normalizedAlarmPoint.id = String(normalizedAlarmPoint.id)
  }

  normalizedAlarmPoint.icon = parsePanelIcon(normalizedAlarmPoint.icon)

  return normalizedAlarmPoint
}

export function normalizeAlarmPanelRows(panel, options = {}) {
  if (!panel?.rows?.length) return panel

  const defaultStyle = options.defaultStyle
  const selectedButton = options.selectedButton

  panel.rows.forEach((row) => {
    if (row.buttons === null) {
      row.buttons = [createEmptyPanelButton()]
    }

    row.buttons.forEach((button) => {
      if (button.style === null) button.style = defaultStyle
      if (button.icon === null || typeof button.icon === 'string') button.icon = parsePanelIcon(button.icon)
      if (button.bgColor === null) button.bgColor = DEFAULT_BACKGROUND_COLOR
      if (button.textColor === null) button.textColor = DEFAULT_TEXT_COLOR
      if (options.stringifyButtonApId && button.apId !== null) button.apId = String(button.apId)

      if (selectedButton
        && button.alarmid === selectedButton.alarmid
        && button.id === selectedButton.id
        && button['custom-name'] === selectedButton['custom-name']
      ) {
        selectedButton.lastjobid = button?.lastjobid
        if (typeof options.onSelectedButtonRefresh === 'function') {
          options.onSelectedButtonRefresh(button?.lastjobid)
        }
      }
    })
  })

  return panel
}

export function canTriggerAlarmPanelButton(authorities = [], alarmPoint = {}, button = null) {
  if (!button || !Array.isArray(authorities)) return false
  if (authorities.includes('SEND_WEB_ALARM')) return true

  const alarmPointId = alarmPoint?.alarmPointId ?? button.alarmid
  return authorities.includes('TRIGGER_AUTOGOING_ALARM')
    && typeof alarmPointId === 'string'
    && alarmPointId.startsWith('$')
}

export function buildAlarmPanelSavePayload(panel, options = {}) {
  const payload = cloneJson(panel, createSelectedAlarmPanel())

  payload.rows?.forEach((row) => {
    row.buttons?.forEach((button) => {
      if (options.clearTemporaryIds && typeof button.id === 'string' && button.id.startsWith('_tmp_')) {
        button.id = ''
      }

      if (typeof button.icon !== 'string') {
        button.icon = JSON.stringify({ ...button.icon, color: button.textColor })
      }
    })
  })

  return payload
}
